import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/StoresPage.css";
import FloatingCartButton from "./FloatingCartButton";
import {getCart} from "../api/cartAPI";
import {getStores} from "../api/storesAPI";
import {useAuth} from "../utils/AuthContext";

const StoresPage = () => {
    const [stores, setStores] = useState([]);
    const [filteredStores, setFilteredStores] = useState([]); // Состояние для фильтрованных магазинов
    const [cart, setCart] = useState([]);
    const [loading, setLoading] = useState(true); // For show loading state
    const [error, setError] = useState(null); // For error handling
    const [searchTerm, setSearchTerm] = useState(""); // Состояние для строки поиска
    const navigate = useNavigate();
    const {isAuthenticated} = useAuth();
    const [showVersion, setShowVersion] = useState(false);

    useEffect(() => {
        if (!isAuthenticated) return

        const fetchData = async () => {
            try {
                setLoading(true);
                console.log("Fetching stores and cart data...");

                // load stores list
                const storesData = await getStores();
                console.log("Stores fetched:", storesData);
                setStores(storesData);
                setFilteredStores(storesData); // Изначально показываем все магазины

                // load cart data
                const cartData = await getCart();
                console.log("Cart fetched:", cartData);
                setCart(cartData);
            } catch (error) {
                console.error("Error during data fetching:", error);
                setError("Помилка завантаження даних. Будь ласка, спробуйте пізніше.");
            } finally {
                setLoading(false); // Hide loading state
            }
        };
        fetchData();
    }, [isAuthenticated]);

    const handleSearchChange = (event) => {
        const term = event.target.value.toLowerCase();
        setSearchTerm(term);

        // Фильтруем магазины по имени или адресу
        const filtered = stores.filter(
            (store) =>
                store.network_name.toLowerCase().includes(term) ||
                store.address.toLowerCase().includes(term)
        );
        setFilteredStores(filtered);
    };

    const handleStoreClick = (storeObj) => {
        try {
            console.log("Selected store:", storeObj);
            navigate(`/catalog/${storeObj.store_id}`, { state: { storeObj } }); // to catalog page
        } catch (error) {
            console.error("Error handling store click:", error);
        }
    };

    if (loading) {
        return <div className="loading"><button onClick={() => navigate('/login')}
        >Завантаження даних...</button></div>;
    }

    if (error) {
        return (
            <div className="error">
                <p>{error}</p>
            </div>
        );
    }

    return (
        <div className="store-list">
            <h1 onClick={() => setShowVersion(!showVersion)}
            >Оберіть магазин</h1>
            {showVersion && <p>Версія 0.0.5</p>}

            {/* Поисковая строка */}
            <div className="search-container">
                <img src="/images/search-icon.svg" alt="search" className="search-icon"/>
                <input
                    type="text"
                    placeholder="Пошук магазину..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className="store-search"
                />
            </div>

            {filteredStores.length === 0 ? (
                <p className="no-stores">Mагазини не знайдено</p>
            ) : (
                <div className="store-list-container">
                    {filteredStores.map((store) => (
                        <div
                            key={store.store_id}
                            className="store-item"
                            onClick={() => handleStoreClick(store)}
                        >

                                <img
                                    src={store.logo || "/images/default_shop_logo.svg"} // Use placeholder logo if not found
                                    alt={store.network_name || "Без названия"}
                                    className="store-logo1"
                                />

                            <div className="store-info1">
                                <h2>{store.network_name || "Без названия"}</h2>
                                <p>{store.address || "Адрес не указан"}</p>
                            </div>
                            <img src="/images/arrow-right.svg" alt='arrow-right' className="store-arrow" />
                        </div>
                    ))}
                </div>
            )}
            {/* cart button */}
            {cart.length > 0 && <FloatingCartButton cartItems={cart.length}/>}
        </div>
    );
};

export default StoresPage;
